import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import DatePicker, { registerLocale } from 'react-datepicker';
import { SimpleFetch, store } from '../../../_helpers';
import { Filter, Trigger, Dcm, Finish } from './_blocks';
import { DcmWeekDaysSelect } from './_blocks/DcmWeekDaysSelect'
import { formSubmit } from './_services';
import moment from 'moment';
import ptBR from 'date-fns/locale/pt-BR';
import './Dcm.manager.scss';

registerLocale('pt-BR', ptBR);

export const DcmManagerContainer = (props) => {
	// States
	const [ domain ] = useState(store.getState().changeDomainReducer.selectedDomain.domain_uuid);
	const [ filters, setFilters ] = useState("");
	const [ loader, setLoader ] = useState({loading: true, loaded: false});
	const [ localData, setLocalData ] = useState({startDate: new Date(), shouldSchedule: false});
	const [ data, setData ] = useState({});
	const [ modal, setModal ] = useState(false);
	
	// Refs
	const form = useRef(null);

	// Start
	useEffect(() => {
    async function listFilters() {
      const res = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/filter/${domain}`);
      if ( res.status !== 200 ) return;

      await setFilters(res.data);
			setLoader({loading: false, loaded: true});
    }
    listFilters();
	}, [domain]);

	// Custom functions
	const handleChange = e => setLocalData({...localData, [e.target.name]: e.target.value})
	const handleSchedule = e => setLocalData({...localData, shouldSchedule: !localData.shouldSchedule})
	const handleModal = e => setModal(!modal)
	const handleSubmit = () => formSubmit(domain, localData, data)

	const handleDateChange = (date, key) => {
    const value = moment(date).format("YYYY-MM-DDTHH:mm:ss") + '.000Z'
    setLocalData({...localData, startDate: date, scheduled_at: value})
  }

	return (
		<>
			<section className="component component-dcm-manager">
				<div className="component-body to-top">
					<div className="container-fluid">
						<div className="row">
							<div className="col">
								<div className="board">
									<form ref={form}>
										<div className="board-canvas">
											{
												!loader.loading ?
													<Filter parentData={{data, setData}} filters={[...filters]} domain={domain} />
												: null
											}
											
											<Trigger parentData={{data, setData}} />
											<DcmWeekDaysSelect data={localData} setData={setLocalData} dataToSearchFinish={data}/>
											<Dcm parentData={{data, setData}} />
											<Finish parentData={{data, setData}} />

											<button type="button" className="btn btn-blue float-right" style={{marginBottom: "15px", marginRight: "0"}} onClick={handleModal}>Salvar</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>

				<Modal
					className="custom-card-modal modal__last-step"
					size="md"
					centered
					show={modal}
					onHide={handleModal}
				>
					<Modal.Body>
						<div className="heading__group">
							<p className="modal__heading--title">Últimos passos</p>
							<button type="button" className="modal__close" onClick={handleModal}><i className="linearicons-cross"></i></button>
							<hr/>
						</div>

						<div className="titled__group">
							<p>Título do GCD</p>
							<input type="text" className="basic-input" placeholder="Ex.: Meu primeiro GCD" name="momentum_title" onChange={handleChange}/>
						</div>

						<div className="switch__group">
							<label htmlFor="disableFilter">Será agendado?</label>
							<input type="checkbox" id="disableFilter" name="disableFilters" onChange={handleSchedule} checked={localData.shouldSchedule} />
							<span className="toggle" htmlFor="disableFilter" data-content={localData.shouldSchedule ? "SIM" : "NÃO"} onClick={handleSchedule}></span>
						</div>

						{
							localData.shouldSchedule ?
								<div className="titled__group">
									<DatePicker
										className="basic-input basic-date-input"
										selected={localData.startDate}
										defaultValue={localData.startDate}
										onChange={handleDateChange}
										showTimeSelect
										placeholder="Defina a data de hora da finalização"
										timeFormat="HH:mm"
										timeIntervals={15}
										timeCaption="Hora"
										dateFormat="dd/MM/yyyy - HH:mm"
									/>
								</div>
							: null
						}

						<button className="btn btn-blue float-right" onClick={(e) => {handleModal(); handleSubmit()}}>Finalizar</button>
					</Modal.Body>
				</Modal>
			</section>
		</>
	)
}